import React from 'react';
import { Row, Col, Panel, Modal, Button } from 'react-bootstrap';
import { fetchApi, withAccessToken } from '../../Network/NetworkService';
import { notif } from '../Ui/Notification';
import dateFormat from 'dateformat';
import { v1 as uuidv1 } from 'uuid';

import IconTooltip from '../Ui/IconTooltip';
import LeadCapitalCounter from '../Ui/LeadCapitalCounter';
import { exportAsExcel } from '../../Services/exportAsExcel';
import { endpoint } from '../../Constants';

const typeList = [
    { value: 'dermatologie', label: 'dermatologie' },
    { value: 'generaliste', label: 'generaliste' },
    { value: 'pediatrie', label: 'pediatrie' },
    { value: 'psychiatre', label: 'psychiatre' },
]


export default class LeadCapital extends React.Component {
    constructor() {
        super();

        this.state = {
            users: [],
            totalPage: 0,
            input: '',
            page: 1,
            countUsers: 0,
            loading: false,
            showExportModal: false,
            showRelanceModal: false,
            startDate: new Date(),
            endDate: new Date(),
            isExporting: false,
            relanceId: uuidv1(),
            relanceLoading: false,
            relanceProgress: '0',
            selectedType: null,
            numberToSend: 1,
            restToSend: 0,
        };

        this.onSort = this.onSort.bind(this);
        this.sortInt = this.sortInt.bind(this);
        this.getUsers = this.getUsers.bind(this);
        this.sendRelance = this.sendRelance.bind(this)
        this.getAll = this.getAll.bind(this)
        this.getRest = this.getRest.bind(this)

    }

    sendRelance() {
            const sendEvent = new EventSource(withAccessToken(`${endpoint}/leadCapital/sendMailProgress?token=${this.state.relanceId}`))
            
            const reset = () => {
                this.setState({ relanceLoading: false, relanceProgress: '0', relanceId: uuidv1(), showRelanceModal: false })
                sendEvent.close()
            }
    
            this.setState({ relanceLoading: true })
    
            sendEvent.onmessage = (ev) => {
    
                if (ev.data === 'start') {
                    fetchApi(`/leadCapital/sendMail`, {
                        method: 'POST',
                        body: JSON.stringify({
                            id: this.state.relanceId,
                        })
                    })
                    .catch((e) => {
                        notif.addNotification(
                            'Erreur',
                            'Erreur d\'envoie !',
                            'warning'
                        )
                        reset()
                    })
                } else if (ev.data === '100') {
                   
                    notif.addNotification(
                        'Success',
                        'Message envoyé !',
                        'success'
                    )
                    reset()                    
                }
                else if (ev.data.includes('error')) {
                    notif.addNotification(
                        'Erreur',
                        ev.data.split('&')[1],
                        'warning'
                    )
                    reset()
                }
                else this.setState({ relanceProgress: ev.data})
            }
    
            sendEvent.onerror = () => {
                notif.addNotification(
                    'Erreur',
                    'Erreur d\'envoie !',
                    'warning'
                )
                reset()
            }
        }
    

    getUsers() {
        this.setState({ loading: true});
   
        fetchApi(`/leadCapital?page=${this.state.page}${this.state.selectedType ? `&type=${this.state.selectedType.value}`: ''}`)
            .then((res) =>
                    this.setState({ users: res.users, totalPage: res.countPages, loading: false, countUsers: res.countUsers })
            )
            .catch((err) =>
                notif.addNotification(
                    'Erreur',
                    'Erreur de recuperation des donnees Utilisateur: ' + err,
                    'warning'
                )
            );
    }

    getAll() {
   
        fetchApi(`/leadCapital/all?limit=${this.state.numberToSend}${this.state.selectedType ? `&type=${this.state.selectedType.value}`: ''}`)
            .then((res) =>
                    this.setState({ relanceLoading: true }, () => this.sendRelance())
            )
            .catch((err) =>
                notif.addNotification(
                    'Erreur',
                    'Erreur de recuperation des donnees Utilisateur: ' + err,
                    'warning'
                )
            );
    }

    getRest() {
   
        fetchApi(`/leadCapital/countRest${this.state.selectedType ? `?type=${this.state.selectedType.value}`: ''}`)
            .then((res) =>
                    this.setState({ restToSend: res.usersCount, showRelanceModal: true })
            )
            .catch((err) =>
                notif.addNotification(
                    'Erreur',
                    'Erreur de recuperation des donnees Utilisateur: ' + err,
                    'warning'
                )
            );
    }

    componentDidMount() {
        this.getUsers();
    }

    updatePage(page) {
        this.setState({ users: [], page, loading: true }, () => {
            fetchApi(`/leadCapital?page=${this.state.page}`)
                .then((res) => {
                    this.setState({ users: res.users, totalPage: res.countPages, loading: false, countUsers: res.countUsers });
                })
                .catch((err) =>
                    notif.addNotification(
                        'Erreur',
                        'Error while getting the users: ' + err,
                        'warning'
                    )
                );
        });
    }

    sortInt(sortKey, sortSecond) {
        const users = this.state.users;

        if (this.state.sort) {
            users.sort((a, b) => a[sortKey][sortSecond] - b[sortKey][sortSecond]);
        } else {
            users.sort((a, b) => b[sortKey][sortSecond] - a[sortKey][sortSecond]);
        }

        this.setState({ users: users, sort: !this.state.sort });
    }

    onSort(sortKey, sortSecond) {
        if (sortSecond) {
            const users = this.state.users;

            if (this.state.sort) {
                users.sort((a, b) =>
                    a[sortKey][sortSecond].localeCompare(b[sortKey][sortSecond])
                );
            } else {
                users.sort((a, b) =>
                    b[sortKey][sortSecond].localeCompare(a[sortKey][sortSecond])
                );
            }
        } else {
            const data = this.state.users;
            if (this.state.sort) {
                data.sort((a, b) => a[sortKey].localeCompare(b[sortKey]));
                this.setState({ sort: false });
            } else {
                data.sort((a, b) => b[sortKey].localeCompare(a[sortKey]));
                this.setState({ sort: true });
            }
            this.setState({ users: data });
        }
    }

  
    
    exportToExcel() {
        
        this.setState({ isExporting: true }, () => {
            fetchApi(`/leadCapital/getExcelData${this.state.selectedType ? `?type=${this.state.selectedType.value}`: ''}`)
            .then((res) => {

                const cls = [
                    { wch: 10 },
                    { wch: 30 },
                    { wch: 30 },
                    { wch: 30 },

                ]

                const toExport = res.users.map((v, idx) => {
                     const d = {
                        '№': idx + 1,
                        'Email': v.email,
                        'Nom et prenom': v.name,
                        'Consultation': v.type,
                    }

                    return d
                });

                

                this.setState({ isExporting: false, showExportModal: false }, () => {
                    notif.addNotification(
                        'Succes !',
                        '',
                        'success'
                    )
                    exportAsExcel(toExport, `leadCapital_${new Date().toISOString()}`, cls);
                } );
                    
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isExporting: false, showFilterModal: false }, () => {
                    notif.addNotification(
                        'Erreur',
                        'Error while getting the users: ' + err,
                        'warning'
                    );
                });
            });
        });
    }

    exportModal() {
        return (
            <Modal show={this.state.showExportModal}>
                <Modal.Header>
                    <Modal.Title>Exporter en excel - File d'attente</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => this.setState({ showExportModal: false })}>Fermer</Button>
                    <Button disabled={this.state.isExporting} onClick={() => this.exportToExcel()} bsStyle="primary">{this.state.isExporting ? 'Chargement ...' : 'Valider'}</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    relanceModal() {
        return (
            <Modal show={this.state.showRelanceModal}>
                <Modal.Header>
                    <Modal.Title>Envoyer pour {this.state.selectedType ? this.state.selectedType.label : 'tous'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                     <div style={{ marginTop: 10 }}>
                            {this.state.relanceLoading ? <p style={{ textAlign: 'center'}}>Envoie en cours : {this.state.relanceProgress} %</p> : (
                                <div>
                                    <div>
                                        <p>Reste a envoyer: {this.state.restToSend}</p>
                                    </div>
                                    <div>
                                        <input min={1} type="number" value={this.state.numberToSend} onChange={(v) => this.setState({ numberToSend: v.target.value })} />
                                    </div>
                                </div>
                            )}
                        </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button disabled={this.state.relanceLoading} onClick={() => this.setState({ showRelanceModal: false })}>Fermer</Button>
                    <Button disabled={!this.state.numberToSend || this.state.numberToSend > this.state.restToSend || this.state.numberToSend <= 0 || this.state.relanceLoading ||  this.state.restToSend === 0} onClick={this.getAll} bsStyle="primary">Valider</Button>
                </Modal.Footer>
            </Modal>
        );
    }

    render() {
        if (!this.state.users) {
            return <div>Récupération des données en cours...</div>;
        }
        const page = this.state.page;

        console.log(this.state.numberToSend);
        

        return (
            <div className="pT-25">
                {this.exportModal()}
                {this.relanceModal()}
                <Row>
                    <Col md={12}>
                        <LeadCapitalCounter 
                            relanceLoading={this.state.relanceLoading} 
                            sendRelance={this.getRest} 
                            typeList={typeList}
                            selectedType={this.state.selectedType}
                            setSelectedType={(v) => this.setState({ selectedType: v }, () => this.getUsers())}
                        />
                        <Panel>
                            <Panel.Heading>
                                <h6>Gestion file d'attente</h6>
                            </Panel.Heading>
                            <Panel.Body>
                            <div style={{ margin: '10px 0' }}>
                                        <button 
                                            className="button-export" 
                                            onClick={() => this.setState({ showExportModal: true })}
                                            disabled={this.state.showExportModal}
                                        >
                                            Exporter en excel
                                        </button>
                                    </div>
                                <div>
                                    <p>
                    Liste des leads (Page <strong>{page}</strong> /{' '}
                                        {this.state.totalPage})
                                    </p>
                                    {page > 1 && (
                                        <IconTooltip
                                            icon="fa fa-chevron-left"
                                            text="Page précédente"
                                            onClick={() => this.updatePage(page - 1)}
                                        />
                                    )}
                                    {page < this.state.totalPage && (
                                        <IconTooltip
                                            icon="fa fa-chevron-right"
                                            text="Page suivante"
                                            onClick={() => this.updatePage(page + 1)}
                                        />
                                    )}
                                </div>
                                <div className="mT-40" />
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('FName')}
                                                >
                                                    Email
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('FName')}
                                                >
                                                    Nom et prenom
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('createdAt')}
                                                >
                                                    Date
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                                 <th
                                                    className="sortable"
                                                    onClick={() => this.onSort('createdAt')}
                                                >
                                                    Type
                                                    <i
                                                        className={
                                                            this.state.sort
                                                                ? 'zmdi zmdi-caret-down'
                                                                : 'zmdi zmdi-caret-up'
                                                        }
                                                    />
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.users.map((d) => (
                                                <tr key={d._id}>
                                                    <td>
                                                        {d.email}
                                                    </td>
                                                    <td>
                                                        {d.name}
                                                    </td>
                                                    <td>{dateFormat(d.createdAt, 'dd/mm/yy HH:MM')}</td>
                                                    <td>
                                                        {d.type}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Panel.Body>
                        </Panel>
                    </Col>
                </Row>
            </div>
        );
    }
}
